import { useState } from "react";
import { AlertTriangle, Loader2, CreditCard } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// Shown on dashboards when a subscriber's last renewal failed.
export default function PastDueBanner() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  if (user?.subscription_status !== "past_due") return null;

  const openPortal = async () => {
    setLoading(true);
    try {
      const r = await api.post("/account/portal", { origin_url: window.location.origin });
      window.location.href = r.data.url;
    } catch (e) {
      toast.error(apiErr(e));
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="past-due-banner"
      className="bg-[#FF3B30] text-white border border-[#0A0A0A] px-5 py-3 mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3"
    >
      <div className="flex items-center gap-2.5">
        <AlertTriangle size={18} className="shrink-0" />
        <span className="text-sm font-medium">
          Your last payment failed. Update your card now to keep your premium access.
        </span>
      </div>
      <button
        data-testid="past-due-update-btn"
        onClick={openPortal}
        disabled={loading}
        className="bg-white text-[#0A0A0A] px-4 py-2 text-sm font-medium inline-flex items-center gap-2 hover:bg-[#0A0A0A] hover:text-white transition-colors disabled:opacity-60 whitespace-nowrap"
      >
        {loading ? <Loader2 size={15} className="animate-spin" /> : <CreditCard size={15} />}
        Update card
      </button>
    </div>
  );
}
